"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiActionComponent = exports.getUiActionComponent = exports.InjectElementToAction = void 0;
var react_1 = require("react");
var Buttons = __importStar(require("../ui/Button"));
var IUiAction_1 = require("./IUiAction");
var getUiActionComponent = function (action, contextModel) {
    var props = {
        onClick: function (ev) { return action.onAction && action.onAction(ev, contextModel); },
        id: action.id,
        target: action.target || null,
        key: action.id
    };
    var buttonProps = __assign({}, props);
    if (action.componentProps) {
        buttonProps = __assign(__assign({}, buttonProps), { isDisabled: action.componentProps.isDisabled, size: action.componentProps.size, type: action.componentProps.type });
    }
    switch (action.rendersIn) {
        case IUiAction_1.UiActionRenderers.HTML_ANCHOR:
            var href = action.hrefFn && typeof action.hrefFn === "function"
                ? action.hrefFn(contextModel)
                : "";
            delete buttonProps.onClick;
            return ((0, react_1.createElement)(Buttons.LinkButton, __assign({}, buttonProps, { externalUrl: href, key: action.id }), action.label));
        case IUiAction_1.UiActionRenderers.LINK_BUTTON:
            if (action.hrefFn && typeof action.hrefFn === "function") {
                buttonProps.href = action.hrefFn(contextModel);
            }
            delete buttonProps.onClick;
            return ((0, react_1.createElement)(Buttons.LinkButton, __assign({}, buttonProps, { key: action.id }), action.label));
        case IUiAction_1.UiActionRenderers.BUTTON:
            return ((0, react_1.createElement)(Buttons.Button, __assign({}, buttonProps, { key: action.id }), action.label));
        case IUiAction_1.UiActionRenderers.BUTTON_ICON:
            var biProps = action.componentProps;
            return ((0, react_1.createElement)(Buttons.ButtonIcon, __assign({}, buttonProps, biProps, { symbol: biProps.symbol, title: action.label, key: action.id })));
        case IUiAction_1.UiActionRenderers.LINK_BUTTON_ICON:
            var bisProps = action.componentProps;
            console.log(action.hrefFn, typeof action.hrefFn === "function");
            if (action.hrefFn && typeof action.hrefFn === "function") {
                bisProps.href = action.hrefFn(contextModel);
            }
            delete bisProps.onClick;
            console.log(bisProps.href);
            return ((0, react_1.createElement)(Buttons.LinkButtonIcon, __assign({}, bisProps, { symbol: bisProps.symbol, key: action.id }), action.label));
        default:
            break;
    }
};
exports.getUiActionComponent = getUiActionComponent;
var InjectElementToAction = function (action, element) {
    var s = __assign({}, action);
    var k = s.onAction;
    s.onAction = function (ev) {
        k(ev, element);
    };
    return s;
};
exports.InjectElementToAction = InjectElementToAction;
var UiActionComponent = function (prop) {
    var action = prop.action, contextModel = prop.contextModel;
    var productTourSelector = action.productTourText !== undefined && action.productTourText.length > 0 ? "product-tour--".concat(action.id) : "";
    var props = {
        onClick: function (ev) { return action.onAction(ev, contextModel); },
        id: action.id,
        key: action.id
    };
    var buttonProps = __assign(__assign({}, props), prop.action.componentProps);
    if (action.componentProps) {
        buttonProps = __assign(__assign({}, buttonProps), { isDisabled: action.componentProps.isDisabled, size: action.componentProps.size, type: action.componentProps.type });
    }
    switch (action.rendersIn) {
        case IUiAction_1.UiActionRenderers.HTML_ANCHOR:
            var href = action.hrefFn && typeof action.hrefFn === "function"
                ? action.hrefFn(contextModel)
                : "";
            delete buttonProps.onClick;
            return ((0, react_1.createElement)(Buttons.LinkButton, __assign({}, buttonProps, { externalUrl: href, key: action.id, tourId: productTourSelector }), action.label));
        case IUiAction_1.UiActionRenderers.LINK_BUTTON:
            if (action.hrefFn && typeof action.hrefFn === "function") {
                buttonProps.href = action.hrefFn(contextModel);
            }
            delete buttonProps.onClick;
            return ((0, react_1.createElement)(Buttons.LinkButton, __assign({}, buttonProps, { key: action.id, tourId: productTourSelector }), action.label));
        case IUiAction_1.UiActionRenderers.BUTTON:
            return ((0, react_1.createElement)(Buttons.Button, __assign({}, buttonProps, { key: action.id, tourId: productTourSelector }), action.label));
        case IUiAction_1.UiActionRenderers.BUTTON_ICON:
            var biProps = action.componentProps;
            return ((0, react_1.createElement)(Buttons.ButtonIcon, __assign({}, buttonProps, biProps, { symbol: biProps.symbol, title: action.label, key: action.id, className: productTourSelector })));
        case IUiAction_1.UiActionRenderers.LINK_BUTTON_ICON:
            var bisProps = action.componentProps;
            if (action.hrefFn && typeof action.hrefFn === "function") {
                bisProps.href = action.hrefFn(contextModel);
            }
            delete bisProps.onClick;
            return ((0, react_1.createElement)(Buttons.LinkButtonIcon, __assign({}, bisProps, { symbol: bisProps.symbol, key: action.id, className: productTourSelector }), action.label));
        default:
            break;
    }
};
exports.UiActionComponent = UiActionComponent;
